module.exports = __webpack_public_path__ + "img/Manu_K_.aac2d3b5.jpg";